// Configuration constants for gallery behavior
const GALLERY_CONFIG = {
	DESKTOP_BREAKPOINT: 1100,        // Pixel width for desktop layout
	THROTTLE_DELAY: 200,              // Milliseconds to throttle resize events
	SLIDER_UPDATE_DELAY_SHORT: 100,  // Short delay for slider updates
	SLIDER_UPDATE_DELAY_MEDIUM: 400, // Medium delay for height calculations
	SLIDER_UPDATE_DELAY_LONG: 800,   // Long delay for complex updates
	INTERACTION_TIMEOUT: 400,         // Max time for user interactions
};

// Utility function to announce slide changes to screen readers
function announceSlideChange(message) {
	let liveRegion = document.getElementById('slide-announcement');
	if (!liveRegion) {
		liveRegion = document.createElement('div');
		liveRegion.id = 'slide-announcement';
		liveRegion.setAttribute('role', 'status');
		liveRegion.setAttribute('aria-live', 'polite');
		liveRegion.setAttribute('aria-atomic', 'true');
		liveRegion.className = 'visually-hidden';
		document.body.appendChild(liveRegion);
	}
	// Clear and announce
	liveRegion.textContent = '';
	setTimeout(() => { liveRegion.textContent = message; }, 100);
}

document.addEventListener("DOMContentLoaded", function () {
	const slideInItems = document.querySelectorAll(".slide-up-animated");
	if (!slideInItems) return;
	slideInItems.forEach((item) => {
		item.classList.add("animation-start");
	});
});
function getSliderSettings() {
	return {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	};
}

function getSubSliderProductSettings() {
	return {
		slidesPerView: "auto",
		direction: "vertical",
		navigation: false,
	};
}

const sliderInit = (isUpdate) => {
	const sliderElement = document.querySelector(".product-section .js-media-list");
	if (!sliderElement) return;
	if (sliderElement.swiper && !isUpdate) return;

	if (!isUpdate && !document.body.classList.contains('slider-ready')) {
		requestAnimationFrame(() => {
			setTimeout(() => {
				document.body.classList.add('slider-ready');
				sliderInit(false);
			}, 0);
		});
		return;
	}

	if (
		document.querySelectorAll(".product-section .js-media-list") &&
		document.querySelectorAll(".product-section .js-media-list").length > 0
	) {
		const thumbSliderElement = document.querySelector(".product-section .js-media-sublist");
		const isBottomThumbs = thumbSliderElement?.classList.contains("js-media-sublist-bottom");
		const isLeftThumbs = thumbSliderElement?.classList.contains("js-media-sublist-left");

		let sliderConfig = {
			slidesPerView: 1,
			spaceBetween: 8,
			speed: 300,
			// Touch gesture improvements
			touchRatio: 1,
			touchAngle: 45,
			threshold: 5,
			longSwipesRatio: 0.5,
			longSwipesMs: 300,
			followFinger: true,
			shortSwipes: true,
			resistanceRatio: 0.85,
			navigation: {
				nextEl: ".swiper-btn--next",
				prevEl: ".swiper-btn--prev",
			},
			pagination: {
				el: ".js-media-list .swiper-pagination",
				clickable: true,
				type: "bullets",
			},
			on: {
				slideChange: function () {
					window.pauseAllMedia();
					this.params.noSwiping = false;

					// Announce slide change to screen readers
					const activeSlide = this.slides[this.activeIndex];
					const slideNumber = this.activeIndex + 1;
					const totalSlides = this.slides.length;
					announceSlideChange(`Viewing image ${slideNumber} of ${totalSlides}`);

					// Move focus to active slide for keyboard navigation
					if (activeSlide && document.activeElement &&
					    (document.activeElement.classList.contains('swiper-btn') ||
					     document.activeElement.classList.contains('product__media-subitem'))) {
						// Only move focus if user was navigating with keyboard
						const focusTarget = activeSlide.querySelector('.product__media-toggle') || activeSlide;
						if (focusTarget && focusTarget.focus) {
							focusTarget.focus({ preventScroll: true });
						}
					}

					// For bottom and left thumbnails, manually update active state and scroll into view
					if (isBottomThumbs || isLeftThumbs) {
						// Use cached thumbSliderElement instead of querying again
						if (thumbSliderElement && thumbSliderElement.swiper) {
							// Get the active main slide's media ID
							const activeMainSlide = this.slides[this.activeIndex];
							const activeMediaId = activeMainSlide?.getAttribute('data-media-id');

							if (!activeMediaId) return;

							// Find matching thumbnail by data-media-sub-id
							const thumbSlides = thumbSliderElement.querySelectorAll('.product__media-subitem');
							let activeThumb = null;

							// Update active class on thumbnails
							thumbSlides.forEach((slide) => {
								const thumbMediaId = slide.getAttribute('data-media-sub-id');
								if (thumbMediaId === activeMediaId) {
									slide.classList.add('swiper-slide-thumb-active');
									activeThumb = slide;
								} else {
									slide.classList.remove('swiper-slide-thumb-active');
								}
							});

							// Smoothly scroll thumbnail into view if needed
							// Use requestAnimationFrame to batch layout reads and avoid forced reflows
							if (activeThumb) {
								requestAnimationFrame(() => {
									const thumbRect = activeThumb.getBoundingClientRect();
									const containerRect = thumbSliderElement.getBoundingClientRect();

									let needsScroll = false;
									let offset = 0;

									if (isBottomThumbs) {
										// Align to left edge if scrolled off to the left
										if (thumbRect.left < containerRect.left) {
											needsScroll = true;
											offset = thumbRect.left - containerRect.left;
										}
										// Align to right edge if scrolled off to the right
										else if (thumbRect.right > containerRect.right) {
											needsScroll = true;
											offset = thumbRect.right - containerRect.right;
										}
									} else {
										// Align to top edge if scrolled off the top
										if (thumbRect.top < containerRect.top) {
											needsScroll = true;
											offset = thumbRect.top - containerRect.top;
										}
										// Align to bottom edge if scrolled off the bottom
										else if (thumbRect.bottom > containerRect.bottom) {
											needsScroll = true;
											offset = thumbRect.bottom - containerRect.bottom;
										}
									}

									if (needsScroll && thumbSliderElement.swiper) {
										const currentTranslate = thumbSliderElement.swiper.getTranslate();
										const newTranslate = currentTranslate - offset;

										thumbSliderElement.swiper.setTransition(300);
										thumbSliderElement.swiper.setTranslate(newTranslate);
									}
								});
							}
						}
					}
				},
				slideChangeTransitionEnd: function () {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						this.slides[this.activeIndex]
							.querySelector(".shopify-model-viewer-ui__button--poster")
							.removeAttribute("hidden");
					}
				},
				touchStart: function (s, e) {
					if (this.slides[this.activeIndex].querySelector("model-viewer")) {
						if (
							!this.slides[this.activeIndex]
								.querySelector("model-viewer")
								.classList.contains("shopify-model-viewer-ui__disabled")
						) {
							this.params.noSwiping = true;
							this.params.noSwipingClass = "swiper-slide";
						}
					}
				},
			},
		};

		let slider = new Swiper(".product-section .js-media-list", sliderConfig);

		// Reset to first slide after initialization
		slider.slideTo(0, 0);

		// Set initial active state for bottom and left thumbnails
		if (isBottomThumbs || isLeftThumbs) {
			setTimeout(function () {
				// Use cached thumbSliderElement instead of querying again
				if (thumbSliderElement && thumbSliderElement.swiper) {
					const thumbSlides = thumbSliderElement.querySelectorAll('.product__media-subitem');
					// Clear any existing active states first
					thumbSlides.forEach(slide => slide.classList.remove('swiper-slide-thumb-active'));
					// Set first thumbnail as active
					if (thumbSlides.length > 0) {
						thumbSlides[0].classList.add('swiper-slide-thumb-active');
					}
				}
			}, GALLERY_CONFIG.SLIDER_UPDATE_DELAY_SHORT);
		}

		const product__button_next = document.querySelector(
			".product__button-next"
		);
		const product__button_prev = document.querySelector(
			".product__button-prev"
		);
		const swiper__button_next = document.querySelector(".swiper-btn--next");
		const swiper__button_prev = document.querySelector(".swiper-btn--prev");
		const sliders = document.querySelector(".product-section .js-media-list");

		if (product__button_prev || product__button_next) {
			if (swiper__button_prev && swiper__button_prev.classList.contains("swiper-button-disabled")) {
				product__button_prev?.classList.add("slider-button-disabled");
			}

			// Remove old event listeners if they exist to prevent memory leaks
			if (product__button_next && product__button_next._nextHandler) {
				product__button_next.removeEventListener("click", product__button_next._nextHandler);
			}
			if (product__button_prev && product__button_prev._prevHandler) {
				product__button_prev.removeEventListener("click", product__button_prev._prevHandler);
			}

			// Store handlers for cleanup on next init
			if (product__button_next) {
				product__button_next._nextHandler = function () {
					if (swiper__button_next && swiper__button_next.classList.contains("swiper-button-disabled")) {
						this.classList.add("slider-button-disabled");
					}

					product__button_prev?.classList.remove("slider-button-disabled");

					if (sliders && sliders.swiper) {
						sliders.swiper.slideNext();
					}
				};
				product__button_next.addEventListener("click", product__button_next._nextHandler);
			}

			if (product__button_prev) {
				product__button_prev._prevHandler = function () {
					if (swiper__button_prev && swiper__button_prev.classList.contains("swiper-button-disabled")) {
						this.classList.add("slider-button-disabled");
					}

					product__button_next?.classList.remove("slider-button-disabled");

					if (sliders && sliders.swiper) {
						sliders.swiper.slidePrev();
					}
				};
				product__button_prev.addEventListener("click", product__button_prev._prevHandler);
			}
		}

		if (isUpdate) {
			setTimeout(function () {
				slider.update();
			}, GALLERY_CONFIG.SLIDER_UPDATE_DELAY_LONG);
		}
	}
};

const subSliderInit = (isUpdate) => {
	if (
		document.querySelectorAll(".product-section .js-media-sublist") &&
		document.querySelectorAll(".product-section .js-media-sublist").length > 0
	) {
		document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {

            if (index >= 1) return

            if (elem.swiper && !isUpdate) return


            const isBottomThumbs = Object.values(elem.classList).includes("js-media-sublist-bottom");
            const isLeftThumbs = Object.values(elem.classList).includes("js-media-sublist-left");

			let subSliderConfig = {
				slidesPerView: "auto",
				spaceBetween: 8,
				direction: isLeftThumbs ? "vertical" : "horizontal",
				freeMode: (isBottomThumbs || isLeftThumbs) ? true : false,
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				autoHeight: (isBottomThumbs || isLeftThumbs) ? false : true,
				on: {
					touchEnd: function (s, e) {
						let range = 5;
						let diff = (s.touches.diff = s.isHorizontal()
							? s.touches.currentX - s.touches.startX
							: s.touches.currentY - s.touches.startY);
						if (diff < range || diff > -range) s.allowClick = true;
					},
					setTranslate: function() {
						// Enforce bounds for bottom and left thumbnails
						if (this._enforcingBounds) return;
						if (isBottomThumbs || isLeftThumbs) {
							const currentTranslate = this.getTranslate();
							const maxTranslate = this.maxTranslate();
							const minTranslate = this.minTranslate();

							if (currentTranslate > minTranslate) {
								this._enforcingBounds = true;
								this.setTranslate(minTranslate);
								this._enforcingBounds = false;
							} else if (currentTranslate < maxTranslate) {
								this._enforcingBounds = true;
								this.setTranslate(maxTranslate);
								this._enforcingBounds = false;
							}
						}
					},
				},
				breakpoints: {
					990: {
						direction: isBottomThumbs ? "horizontal" : "vertical",
						centeredSlides: false,
						allowTouchMove: true,
					},
				},
			};

			// For bottom and left thumbnails, enable dragging but no navigation arrows
			if (isBottomThumbs || isLeftThumbs) {
				subSliderConfig.freeMode = {
					enabled: true,
					sticky: false,
					momentumBounce: false,
					momentumRatio: 0.5,
					momentumVelocityRatio: 0.5,
				};
				subSliderConfig.mousewheel = {
					forceToAxis: true,
				};
				subSliderConfig.resistanceRatio = 0;
				subSliderConfig.watchOverflow = true;
			}

			let subSlider = new Swiper(".product-section .js-media-sublist", subSliderConfig);

			// Add click and keyboard handlers for bottom and left thumbnails using event delegation
			if (isBottomThumbs || isLeftThumbs) {
				// Remove old event listeners if they exist
				if (elem._clickHandler) {
					elem.removeEventListener('click', elem._clickHandler);
				}
				if (elem._keydownHandler) {
					elem.removeEventListener('keydown', elem._keydownHandler);
				}

				// Create new click/keyboard event handler
				const navigateToSlide = function(thumb) {
					const mainSlider = document.querySelector(".product-section .js-media-list");
					if (!mainSlider || !mainSlider.swiper) return;

					// Get the clicked thumbnail's media ID
					const thumbMediaId = thumb.getAttribute('data-media-sub-id');
					if (!thumbMediaId) return;

					// Find the matching main slide by data-media-id
					const mainSlides = mainSlider.querySelectorAll('.product__media-item');
					let targetIndex = -1;

					mainSlides.forEach((slide, index) => {
						if (slide.getAttribute('data-media-id') === thumbMediaId) {
							targetIndex = index;
						}
					});

					if (targetIndex >= 0) {
						mainSlider.swiper.slideTo(targetIndex);
					}
				};

				// Click handler
				elem._clickHandler = function(e) {
					const thumb = e.target.closest('.product__media-subitem');
					if (thumb) {
						navigateToSlide(thumb);
					}
				};

				// Keyboard handler for Enter and Space
				elem._keydownHandler = function(e) {
					if (e.key === 'Enter' || e.key === ' ') {
						const thumb = e.target.closest('.product__media-subitem');
						if (thumb) {
							e.preventDefault(); // Prevent page scroll on Space
							navigateToSlide(thumb);
						}
					}
				};

				// Add event listeners to parent container
				elem.addEventListener('click', elem._clickHandler);
				elem.addEventListener('keydown', elem._keydownHandler);

				// Make thumbnails keyboard focusable
				elem.querySelectorAll('.product__media-subitem').forEach((thumb, index) => {
					thumb.setAttribute('tabindex', '0');
					thumb.setAttribute('role', 'button');
					thumb.setAttribute('aria-label', 'View image ' + (index + 1));
				});
			}

			setTimeout(function () {
				const sliders = document.querySelectorAll(".js-media-list");
				const thumbs = document.querySelectorAll(".product__media-sublist");

				// Add bounds check before accessing array indices
				if (sliders[index] && thumbs[index]) {
					const sliderHeight = sliders[index].getBoundingClientRect().height;

					// Only set height for vertical (non-bottom) thumbnails
					if (!isBottomThumbs) {
						thumbs[index].style.height = `${sliderHeight - 1}px`;
					}
				}
			}, GALLERY_CONFIG.SLIDER_UPDATE_DELAY_MEDIUM);

			if (isUpdate) {
				setTimeout(function () {
					subSlider.update();
				}, GALLERY_CONFIG.SLIDER_UPDATE_DELAY_LONG);
			}
		});
    }
};

function updatethumbnail() {
	let productList = document.querySelector(".product__media-list");
	let mediaThumbHeight = document.querySelector(".product__media-sublist");

	if (productList && mediaThumbHeight) {
		let mediaHeight = productList.offsetHeight;

		if (window.innerWidth > GALLERY_CONFIG.DESKTOP_BREAKPOINT && mediaHeight > 0) {
			mediaThumbHeight.style.height = mediaHeight + "px";
		}
		if (window.innerWidth <= GALLERY_CONFIG.DESKTOP_BREAKPOINT) {
			mediaThumbHeight.style.height = "100%";
		}
	}
}

// Throttle utility to limit function execution frequency
function throttle(func, wait) {
	let timeout = null;
	let lastRan = 0;

	return function(...args) {
		const now = Date.now();

		// Clear any pending timeout
		if (timeout) {
			clearTimeout(timeout);
		}

		// If enough time has passed, execute immediately
		if (now - lastRan >= wait) {
			func.apply(this, args);
			lastRan = now;
		} else {
			// Otherwise, schedule for later (trailing edge)
			timeout = setTimeout(() => {
				func.apply(this, args);
				lastRan = Date.now();
				timeout = null;
			}, wait - (now - lastRan));
		}
	};
}

function getAllSections() {
	return document.querySelectorAll("section");
}

// Throttled resize handler - limits execution to once per 200ms
const handleResize = throttle(() => {
	getAllSections().forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			updatethumbnail();
		}
	});
}, GALLERY_CONFIG.THROTTLE_DELAY);

window.addEventListener("resize", handleResize);

document.addEventListener("visibilitychange", function () {
	getAllSections().forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, GALLERY_CONFIG.THROTTLE_DELAY);
		}
	});
});

// Intersection Observer for optimized image loading
// Loads images slightly before they enter viewport for smoother UX
if ('IntersectionObserver' in window) {
	const imageObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const img = entry.target;

				if (img.complete && img.naturalHeight !== 0) {
					img.classList.add('lazy-loaded');
					observer.unobserve(img);
					return;
				}

				img.classList.add('lazy-loading');

				// Image will load via native lazy loading
				// This observer just adds the visual feedback
				img.addEventListener('load', () => {
					img.classList.remove('lazy-loading');
					img.classList.add('lazy-loaded');
				}, { once: true });

				// Handle image load errors gracefully
				img.addEventListener('error', () => {
					img.classList.remove('lazy-loading');
					img.classList.add('lazy-error');
					// Set a placeholder or keep the container visible
					img.alt = img.alt || 'Image failed to load';
				}, { once: true });

				// Fallback: remove loading class after timeout if load event doesn't fire
				setTimeout(() => {
					if (img.classList.contains('lazy-loading')) {
						img.classList.remove('lazy-loading');
						img.classList.add('lazy-loaded');
					}
				}, 2000);

				// Stop observing this image
				observer.unobserve(img);
			}
		});
	}, {
		// Load images 200px before they enter viewport
		rootMargin: '200px 0px',
		threshold: 0.01
	});

	// Observe all lazily loaded images in product gallery
	document.addEventListener('DOMContentLoaded', () => {
		const lazyImages = document.querySelectorAll('.product__media img[loading="lazy"]');
		lazyImages.forEach(img => imageObserver.observe(img));
	});

	// Re-observe images after variant changes
	document.addEventListener('variant:change', () => {
		setTimeout(() => {
			const lazyImages = document.querySelectorAll('.product__media img[loading="lazy"]');
			lazyImages.forEach(img => {
				if (!img.classList.contains('lazy-loaded')) {
					imageObserver.observe(img);
				}
			});
		}, 100);
	});
}

document.addEventListener("DOMContentLoaded", function () {
	getAllSections().forEach((prodSection) => {
		if (prodSection.classList.contains("product-section")) {
			setTimeout(() => {
				updatethumbnail();
			}, GALLERY_CONFIG.THROTTLE_DELAY);
		}
	});
});

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", "false");

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.querySelectorAll("button").forEach((button) =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);

		var eventList = ["paste", "input"];

		for (event of eventList) {
			this.input.addEventListener(event, function (e) {
				const numberRegex = /^0*?[1-9]\d*$/;

				if (
					numberRegex.test(e.currentTarget.value) ||
					e.currentTarget.value === ""
				) {
					e.currentTarget.value;
				} else {
					e.currentTarget.value = 1;
				}
			});
		}

		this.input.addEventListener("focusout", function (e) {
			if (e.currentTarget.value === "") {
				e.currentTarget.value = 1;
			}
		});
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

const serializeForm = (form) => {
	const obj = {};
	const formData = new FormData(form);
	for (const key of formData.keys()) {
		obj[key] = formData.get(key);
	}
	return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");
		const summaryElements = this.querySelectorAll("summary");
		this.addAccessibilityAttributes(summaryElements);

		if (navigator.platform === "iPhone")
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			);

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach((summary) =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		this.querySelectorAll("button").forEach((button) => {
			if (this.querySelector(".header__localization-button") === button) return;
			if (this.querySelector(".header__localization-lang-button") === button)
				return;
			button.addEventListener("click", this.onCloseButtonClick.bind(this));
		});
	}

	addAccessibilityAttributes(summaryElements) {
		summaryElements.forEach((element) => {
			element.setAttribute("role", "button");
			element.setAttribute("aria-expanded", false);
			element.setAttribute("aria-controls", element.nextElementSibling.id);
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute("open");

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);

			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
			});
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove("menu-opening");
			this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
				details.removeAttribute("open");
				details.classList.remove("menu-opening");
			});
			this.mainDetailsToggle
				.querySelector("summary")
				.setAttribute("aria-expanded", false);
			document.body.classList.remove(
				`overflow-hidden-${this.dataset.breakpoint}`
			);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening");
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < GALLERY_CONFIG.INTERACTION_TIMEOUT) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header =
			this.header || document.querySelector(".shopify-section-header");
		this.borderOffset =
			this.borderOffset ||
				this.closest(".header-wrapper").classList.contains(
					"header-wrapper--border-bottom"
				)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false)
		);
		this.addEventListener("keyup", (event) => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", (event) => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", (event) => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide(isProductPage = false) {
		let isOpen = false

		this.removeAttribute('open')

		removeTrapFocus(this.openedBy)

		window.pauseAllMedia()

		document.querySelectorAll("body > quick-add-modal").forEach((el) => {
			if (el.hasAttribute("open")) {
				isOpen = true;
			}
		});

		if (!isOpen) {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
		}
	}
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		this.posterButton = this.querySelector('[id^="Deferred-Poster-"]');
		this.boundLoadContent = this.loadContent.bind(this);

		if (this.posterButton) {
			this.posterButton.addEventListener("click", this.boundLoadContent);
		}
		if (this.getAttribute("data-autoplay")) {
			this.loadContent();
		}
	}

	disconnectedCallback() {
		// Clean up event listener to prevent memory leaks
		if (this.posterButton && this.boundLoadContent) {
			this.posterButton.removeEventListener("click", this.boundLoadContent);
		}
	}

	loadContent() {
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			);
			this.setAttribute("loaded", true);
			window.pauseAllMedia();
			const videoObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (this.getAttribute("data-autoplay")) {
							let playPromise = entry.target.play();
							if (playPromise !== undefined) {
								playPromise.then((_) => { }).catch((error) => { });
							}
						}
					} else {
						entry.target.pause();
					}
				});
			});
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);

			if (
				deferredElement.nodeName == "VIDEO" ||
				deferredElement.nodeName == "IFRAME"
			) {
				// force autoplay for safari

				if (this.classList.contains("video-section__media")) {
					let playPromise = deferredElement.play();
					if (playPromise !== undefined) {
						playPromise.then((_) => { }).catch((error) => { });
					}
					videoObserver.observe(deferredElement);
				} else {
					deferredElement.play();
				}
			}
			if (
				this.closest(".swiper")?.swiper.slides[
					this.closest(".swiper").swiper.activeIndex
				].querySelector("model-viewer")
			) {
				if (
					!this.closest(".swiper")
						.swiper.slides[
						this.closest(".swiper").swiper.activeIndex
					].querySelector("model-viewer")
						.classList.contains("shopify-model-viewer-ui__disabled")
				) {
					this.closest(".swiper").swiper.params.noSwiping = true;
					this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
				}
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector(".slider");
		this.sliderItems = this.querySelectorAll(".slider__slide");
		this.pageCount = this.querySelector(".slider-counter--current");
		this.pageTotal = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		this.resizeObserver = new ResizeObserver((entries) => this.initPages());
		this.resizeObserver.observe(this.slider);

		// Store bound handlers for cleanup
		this.boundUpdate = this.update.bind(this);
		this.boundButtonClick = this.onButtonClick.bind(this);

		this.slider.addEventListener("scroll", this.boundUpdate);
		this.prevButton.addEventListener("click", this.boundButtonClick);
		this.nextButton.addEventListener("click", this.boundButtonClick);
	}

	disconnectedCallback() {
		// Clean up event listeners and observers to prevent memory leaks
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
		if (this.slider && this.boundUpdate) {
			this.slider.removeEventListener("scroll", this.boundUpdate);
		}
		if (this.prevButton && this.boundButtonClick) {
			this.prevButton.removeEventListener("click", this.boundButtonClick);
		}
		if (this.nextButton && this.boundButtonClick) {
			this.nextButton.removeEventListener("click", this.boundButtonClick);
		}
	}

	initPages() {
		if (this.sliderItems.length === 0) return;
		this.slidesPerPage = Math.floor(
			this.slider.clientWidth / this.sliderItems[0].clientWidth
		);
		this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute("disabled", true);
		} else {
			this.prevButton.removeAttribute("disabled");
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute("disabled", true);
		} else {
			this.nextButton.removeAttribute("disabled");
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + this.sliderItems[0].clientWidth
				: this.slider.scrollLeft - this.sliderItems[0].clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
        this.updateVariantStatuses();
        this.updateVariantName();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateMediaSub();
			if (
				this.currentVariant?.featured_media &&
				this.dataset?.variantMediaDisplay === "show_all"
			) {
				this.updateMedia()
			}

			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}

		// VARIANT CHANGE EVENT
		if (this.currentVariant) {
			document.dispatchEvent(
				new CustomEvent("variant:change", {
					detail: {
						variant: this.currentVariant,
						previousVariant: this.previousVariant || null,
						formElement: document.querySelector(
							`#product-form-${this.dataset.section}`
						),
						sectionId: this.dataset.section
					}
				})
			);

			// Announce variant change to screen readers
			this.announceToScreenReader(
				`Selected ${this.currentVariant.title}. Price: ${this.formatPrice(this.currentVariant.price)}`
			);

			// Save the previous version
			this.previousVariant = this.currentVariant;
		}
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value
		).concat(
			fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll("input")).find(
					(radio) => radio.checked
				).value;
			})
		);
	}

	updateMasterId() {
		if (this.variantData || this.querySelector('[type="application/json"]')) {
			this.currentVariant = this.getVariantData().find((variant) => {
				this.options.sort();
				variant.options.sort();

				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}
	}

	updateMedia() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		const newMediaMobile = document.querySelector(
			`[data-mobile-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		if (!newMedia) return;

		const parent = newMedia.parentElement;

		parent.prepend(newMedia);

		window.setTimeout(() => {
			parent.scroll(0, 0);
		});

		if (newMediaMobile) {
			const parentMobile = newMediaMobile.parentElement;

			parentMobile.prepend(newMediaMobile);

			window.setTimeout(() => {
				parentMobile.scroll(0, 0);
			});
		}

		// Destroy main slider before reinitializing
		const mediaListElement = document.querySelector(".js-media-list");
		if (mediaListElement && mediaListElement.swiper != null) {
			mediaListElement.swiper.destroy();
		}

		if (mediaListElement) {
			sliderInit(true);
		}
	}

	updateMediaSub() {
		if (!this.currentVariant || !this.currentVariant?.featured_media) return;

		const newMediaSub = document.querySelector(
			`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		);

		// Clear all active states from thumbnails before reordering
		document.querySelectorAll('.product__media-subitem').forEach((el) => {
			el.classList.remove('swiper-slide-thumb-active', 'active');
		});

		const mediaSublistElement = document.querySelector(".js-media-sublist");
		if (mediaSublistElement && mediaSublistElement.swiper != null) {
			mediaSublistElement.swiper.destroy();
		}

		if (!newMediaSub) return;

		const parentSub = newMediaSub.parentElement;

		parentSub.prepend(newMediaSub);

		window.setTimeout(() => {
			parentSub.scroll(0, 0);
		});

		if (mediaSublistElement) {
			subSliderInit(true);
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(":checked").value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [
				...option.querySelectorAll('input[type="radio"], option'),
			];
			const previousOptionSelected =
				inputWrappers[index - 1].querySelector(":checked").value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available &&
						variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
    }
    
	updateVariantName() {
		const swatchColorName = document.querySelector('.js-swatch-color-name');
		if (!swatchColorName) return;

		const optionPosition = swatchColorName.dataset.optionPosition || '1';
		const optionKey = `option${optionPosition}`;

		if (this.previousVariant?.[optionKey] === this.currentVariant?.[optionKey]) return;

		const rawName = this.currentVariant[optionKey];
		// swatchColorName.textContent = this.cleanColorName(rawName);
		swatchColorName.textContent = rawName;
	}

	cleanColorName(name) {
		if (!name) return '';

		// Handle various dash patterns (e.g., "Silver - 25", "Teal -46", "Teal- 46")
		if (name.includes(' - ')) {
			name = name.split(' - ')[0];
		}
		if (name.includes(' -')) {
			name = name.split(' -')[0];
		}
		if (name.includes('- ')) {
			name = name.split('- ')[0];
		}

		// Handle trailing number patterns (e.g., "Turquoise 63", "Pink 22a")
		const words = name.split(' ');
		const lastWord = words[words.length - 1];

		// Check if last word starts with a digit or dash
		if (/^[-\d]/.test(lastWord) && words.length > 1) {
			words.pop();
			name = words.join(' ');
		}

		return name;
	}

	formatPrice(price) {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD'
		}).format(price / 100);
	}

	announceToScreenReader(message) {
		// Create or get live region for announcements
		let liveRegion = document.getElementById('variant-announcement');
		if (!liveRegion) {
			liveRegion = document.createElement('div');
			liveRegion.id = 'variant-announcement';
			liveRegion.setAttribute('role', 'status');
			liveRegion.setAttribute('aria-live', 'polite');
			liveRegion.setAttribute('aria-atomic', 'true');
			liveRegion.className = 'visually-hidden';
			document.body.appendChild(liveRegion);
		}

		// Clear and announce new message
		liveRegion.textContent = '';
		setTimeout(() => {
			liveRegion.textContent = message;
		}, 100);
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				if (input.tagName === "OPTION") {
					input.innerText = input.getAttribute("value");
				} else if (input.tagName === "INPUT") {
					input.classList.remove("disabled");
				}
			} else {
				if (input.tagName === "OPTION") {
					input.innerText =
						window.variantStrings.unavailable_with_option.replace(
							"[value]",
							input.getAttribute("value")
						);
				} else if (input.tagName === "INPUT") {
					input.classList.add("disabled");
				}
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
				? this.dataset.originalSection
				: this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, "text/html");
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				);
				const source = html.getElementById(
					`price-${this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
					}`
				);
				const skuSource = html.getElementById(
					`Sku-${this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
					}`
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				);
				const inventorySource = html.getElementById(
					`Inventory-${this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
					}`
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				);

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden")
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === ""
					);

				const addButtonUpdated = html.getElementById(
					`ProductSubmitButton-${sectionId}`
				);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
					window.variantStrings.soldOut
				)

				if (this.dataset?.variantMediaDisplay !== 'show_all') {
					const sourceSectionId = this.dataset.originalSection
						? this.dataset.originalSection
						: this.dataset.section
					const currentSectionId = this.dataset.section
					const mediaSource = html.querySelector(
						`[data-section="product-media-${sourceSectionId}"]`
					)
					const mediaDestination = document.querySelector(
						`[data-section="product-media-${currentSectionId}"]`
					)

					if (mediaSource && mediaDestination) {
						mediaDestination.innerHTML = mediaSource.innerHTML
						const parentQuickView = this.closest('quick-add-modal')
						if (parentQuickView) {
							if (
								typeof parentQuickView.removeDOMElements === 'function'
							) {
								parentQuickView.removeDOMElements(
									mediaDestination
								)
							}
							if (
								typeof parentQuickView.initSlider === 'function'
							) {
								parentQuickView.initSlider()
							}
						} else {
							const section = document.getElementById(
								`shopify-section-${currentSectionId}`
							)
							if (section && typeof initProductPage === 'function') {
								initProductPage(section)
							}
						}
						if (document.querySelector('.js-media-list')) {
							subSliderInit(true)
							sliderInit(true)
						}
					}
				}
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelectorAll('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");

			if (text) {
				addButtonText.forEach((elem) => {
					elem.innerHTML = `${text}`;
				});
			}
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.forEach((elem) => {
				elem.innerHTML = `${window.variantStrings.addToCart}`;
			});
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelectorAll('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.forEach((elem) => {
			elem.innerHTML = `${window.variantStrings.unavailable}`;
		});
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	disconnectedCallback() {
		// Clean up event listener to prevent memory leaks
		this.removeEventListener("change", this.onVariantChange);
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll("input")).find(
				(radio) => radio.checked
			).value;
		});
	}
}

customElements.define("variant-radios", VariantRadios);

class ProductModel extends DeferredMedia {
	constructor() {
		super();
	}

	loadContent() {
		super.loadContent();

		Shopify.loadFeatures([
			{
				name: "model-viewer-ui",
				version: "1.0",
				onLoad: this.setupModelViewerUI.bind(this),
			},
		]);
	}

	setupModelViewerUI(errors) {
		if (errors) return;

		this.modelViewerUI = new Shopify.ModelViewerUI(
			this.querySelector("model-viewer")
		);

		const $this = this;

		this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
			"click",
			function () {
				if (
					$this
						.closest(".swiper")
						.swiper.slides[
						$this.closest(".swiper").swiper.activeIndex
					].querySelector("model-viewer")
				) {
					if (
						!$this
							.closest(".swiper")
							.swiper.slides[
							$this.closest(".swiper").swiper.activeIndex
						].querySelector("model-viewer")
							.classList.contains("shopify-model-viewer-ui__disabled")
					) {
						if (
							$this
								.querySelector(".shopify-model-viewer-ui__button")
								.hasAttribute("hidden")
						) {
							$this.closest(".swiper").swiper.params.noSwiping = true;
							$this.closest(".swiper").swiper.params.noSwipingClass =
								"swiper-slide";
						}
					}
				}
			}
		);

		this.querySelector(
			".shopify-model-viewer-ui__controls-overlay"
		).addEventListener("click", function () {
			if (
				!$this
					.querySelector(".shopify-model-viewer-ui__button")
					.hasAttribute("hidden")
			) {
				$this.closest(".swiper").swiper.params.noSwiping = false;
			}
		});
	}
}
customElements.define("product-model", ProductModel);

// Product slider

(function () {
	const productSlider = () => {
		const productSliders = Array.from(
			document.querySelectorAll(".products-slider")
		);
		if (productSliders.length === 0) return;

		const SECTION_ALWAYS_SHOW_FOUR_ITEMS_ID = "shopify-section-template--24544616677651__31f1d4fa-27c9-4df0-93b7-f5d685f3f66f";
		productSliders.forEach((slider) => {
			const slides = slider.querySelectorAll(".swiper-slide");
			const doesEverySlideHaveDataTypeAttribute = Array.from(slides).every(slide => slide.hasAttribute("data-type"));

			if (slider.dataset.id === SECTION_ALWAYS_SHOW_FOUR_ITEMS_ID && !doesEverySlideHaveDataTypeAttribute) {
				slides.forEach((slide, index) => {
					if (index >= 4) {
						slide.remove();
					}
				});
			};
			const sectionId = slider.dataset.id;
			const perRow = slider.dataset.perRow;
			const mobileR = slider.dataset.mobile;
			const speed = slider.dataset.speed * 1000;
			const delay = slider.dataset.delay * 1000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const stopAutoplay = toBoolean(slider.dataset.stopAutoplay);
			const showArrows = toBoolean(slider.dataset.showArrows);
			let autoplayParm = {};
			let arrowsParm = {};
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}
			if (showArrows) {
				arrowsParm = {
					navigation: {
						nextEl: `#${sectionId} .swiper-button-next`,
						prevEl: `#${sectionId} .swiper-button-prev`,
					},
					pagination: {
						el: `#${sectionId} .swiper-pagination`,
						clickable: true,
					},
				};
			}

			let swiperParms = {
				speed: speed,
				keyboard: true,
				slidesPerView: mobileR,
				spaceBetween: 16,
				breakpoints: {
					//576: {
					//	slidesPerView: 2,
					//},
					1100: {
						spaceBetween: 16,
						slidesPerView: perRow,
					},
				},
				...arrowsParm,
				...autoplayParm,
			};

			const swiper = new Swiper(`#${sectionId} .swiper`, swiperParms);
		});
	};

	function toBoolean(string) {
		return string === "true" ? true : false;
	}
	if (document.querySelector("product-recommendations") !== null) {
		const initslider = setInterval(() => {
			if (
				document
					.querySelector("product-recommendations")
					.querySelector(".swiper") !== null
			) {
				if (
					document
						.querySelector("product-recommendations")
						.querySelector(".swiper")
						.classList.contains("swiper-initialized")
				) {
					clearInterval(initslider);
				}
				productSlider();
			}
		}, 100);
	}
	document.addEventListener("DOMContentLoaded", function () {
		productSlider();
		document.addEventListener("shopify:section:load", function () {
			productSlider();
		});
	});
})();

(function () {
	let image = document.querySelectorAll(".data-alt img");
	image &&
		image.forEach((img, index) => {
			img.alt = "Video background";
		});
})();

(function () {
	const hoverOpacity = () => {
		$("[data-hover-opacity]").hover(
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).removeClass("opacity");
			}
		);
	};
	document.addEventListener("DOMContentLoaded", function () {
		hoverOpacity();
		document.addEventListener("shopify:section:load", function () {
			hoverOpacity();
		});
	});
})();

(function () {
	const dropdowncolor = () => {
		$(".list-choice-before").click(function () {
			$(".list-choice").removeClass("expanded");
		});
		$(".list-choice-btn").click(function (e) {
			$(this).addClass("expanded");
			$(".first_label").each(function (index, item) {
				$(this).removeClass("active_label");
				$(item.children[0]).change(function () {
					if ($(this).is(":checked")) {
						$(".list-choice").removeClass("expanded");
					}
				});
			});

			const first_label_input = document.querySelectorAll(
				'.first_label input[type="radio"]:checked'
			);

			const first_label = document.querySelectorAll(".first_label");

			first_label_input.forEach(function (item, index) {
				item.parentNode.classList.add("active_label");
			});

			first_label.forEach(function (item, index) {
				item.addEventListener("click", function () {
					document.activeElement.blur();
				});
			});

			if ($(this).hasClass("expanded")) {
				e.stopPropagation();
				$(document).click(function () {
					$(".list-choice").removeClass("expanded");
				});
			}
		});
	};
	document.addEventListener("DOMContentLoaded", function () {
		dropdowncolor();
		document.addEventListener("shopify:section:load", function () {
			dropdowncolor();
		});
	});
})();

(function () {
	const sidebar = () => {
		let pageNav = $(".product__media-sublist__sidebar-nav");

		if (pageNav.length > 0) {
			let pageNavList = pageNav.find("a");
			let adminBarHeight = 0;

			let headings = [];
			for (let i = 0; i < pageNavList.length; i++) {
				headings[i] = $($(pageNavList[i]).attr("href"));
			}

			$(pageNavList[0]).parent().addClass("active");

			$(window).on("scroll", function () {
				for (let i = headings.length; i >= 0; i--) {
					if ($(headings[i]).length > 0) {
						if (
							$(headings[i]).offset().top - 50 <=
							$(window).scrollTop() + adminBarHeight
						) {
							if (!$(pageNavList[i]).parent().hasClass("active")) {
								let hasActiveItem = false;
								for (let j = i; j < headings.length; j++) {
									if ($(pageNavList[j]).parent().hasClass("active")) {
										hasActiveItem = true;
									}
								}

								if (!hasActiveItem) {
									$(pageNavList[i]).parent().addClass("active");
									if (
										$(pageNavList[i])
											.parent()
											.hasClass("product__media-subitem__sidebar-sublist-item")
									) {
									}

									history.pushState(
										null,
										null,
										window.location.origin +
										window.location.pathname +
										$(pageNavList[i]).attr("href")
									);
								}
							} else {
								for (let j = 0; j < i; j++) {
									$(pageNavList[j]).parent().removeClass("active");
								}
							}
						} else {
							if (i !== 0) {
								$(pageNavList[i]).parent().removeClass("active");
							}
						}
					}
				}
			});
		}
	};
	document.addEventListener("DOMContentLoaded", function () {
		sidebar();
		document.addEventListener("shopify:section:load", function () {
			sidebar();
		});
	});
})();

(function () {
	const initHeaderOverlay = () => {
		const main = document.getElementById("MainContent");
		const sections = main.querySelectorAll(".shopify-section");

		if (sections.length > 0) {
			const sectionFirstChild = sections[0].querySelector(
				"[data-header-overlay]"
			);
			const headerGroupSections = document.querySelectorAll(
				".shopify-section-group-header-group"
			);
			const header = document.querySelector(".shopify-section-header");
			const breadcrumbs = document.querySelector("body > .breadcrumbs-wrapper");

			if (!header) return;

			if (sectionFirstChild) {
				if (headerGroupSections[headerGroupSections.length - 1] === header) {
					sections[0].classList.add("section--has-overlay");
					header.classList.add("color-background-overlay");
					if (breadcrumbs) breadcrumbs.classList.add("color-background-3");
				} else {
					sections[0].classList.remove("section--has-overlay");
					header.classList.remove("color-background-overlay");
					if (breadcrumbs) breadcrumbs.classList.remove("color-background-3");
				}
			} else {
				sections[0].classList.remove("section--has-overlay");
				header.classList.remove("color-background-overlay");
				if (breadcrumbs) breadcrumbs.classList.remove("color-background-3");
			}
		}
	};

	initHeaderOverlay();

	document.addEventListener("shopify:section:load", initHeaderOverlay);
	document.addEventListener("shopify:section:unload", initHeaderOverlay);
	document.addEventListener("shopify:section:reorder", initHeaderOverlay);
})();


// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
	const sectionsToUpdate = [
		{ id: "cart-icon-bubble", selector: "#cart-icon-bubble" },
		{ id: "cart-drawer", selector: "cart-drawer" },
		{ id: "main-cart-items", selector: "#main-cart-items" },
		{ id: "main-cart-footer", selector: "#main-cart-footer" }
	];
	sectionsToUpdate.forEach((section) => {
		fetch(`${routes.cart_url}?section_id=${section.id}`)
			.then((response) => response.text())
			.then((html) => {
				const parsedHTML = new DOMParser().parseFromString(html, "text/html");
				const source = parsedHTML.querySelector(section.selector);
				const target = document.querySelector(section.selector);
				if (source && target) {
					target.innerHTML = source.innerHTML;
					if (section.selector === 'cart-drawer' && typeof target.bindOverlay === 'function') {
						target.bindOverlay();
					}
				}
			})
			.catch((e) => console.error(`[cart:refresh] error updating ${section.id}`, e));
	});
});


// CART REFRESH EVENT END
// -----------------------------------------------------------------------------

